var React = require('react');

function BannerBottomInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M777.5 49.6363C1012.7 78.4363 1317.17 44.6364 1440 24.1364L1440 0.136353L-0.999995 0.136227L-0.999999 44.1362C254 18.1362 483.5 13.6363 777.5 49.6363Z","fill":"#DD3F45"}));
}

BannerBottomInline.defaultProps = {"width":"1440","height":"61","viewBox":"0 0 1440 61","fill":"none"};

module.exports = BannerBottomInline;

BannerBottomInline.default = BannerBottomInline;
